const COUNTRY_CURRENCY_MAPPING = {
  US: 'USD',
  CA: 'CAD',
  CN: 'CNY',
  HK: 'HKD',
  MX: 'MXN',
  TR: 'TRY',
  BR: 'BRL',
  TW: 'TWD',
  CZ: 'CZK',
  DK: 'DKK',
  PL: 'PLN',
  SE: 'SEK',
};
export default COUNTRY_CURRENCY_MAPPING;
